/* eventTrigger.js */

import breakpoints from './breakpoints';

export default function () {
    // init event triggers

    let triggerEls = document.querySelectorAll('[data-evtrigger]');
    let scrollTriggerEls = [];

    for(let el of triggerEls) {
        let trigger = el.getAttribute('data-evtrigger');
        let receiver = el.getAttribute('data-evtriggers');

        switch (trigger) {
            case 'click':
                el.addEventListener('click', () => clickCB(el, receiver));
                break;
            case 'scroll':
                scrollTriggerEls.push(el);
                break;
            case 'hover':
                el.addEventListener('mouseover', ()=>hoverCB(el, receiver, true));
                break;
            default:
                break;
        }
    }

    document.addEventListener('scroll', () => scrollCB(scrollTriggerEls));
}

// click event cb
function clickCB(triggerEl, receiverEl){
    let evType = triggerEl.getAttribute('data-evtype');
    switch (evType) {
        case 'triggerMobileNav':
            triggerMobileNav(triggerEl);
            break;
        case 'triggerMobileSubmenu':
            toggleMobileSubmenu(triggerEl, receiverEl, true);
            break;
        case 'closeMobileSubmenu':
            toggleMobileSubmenu(triggerEl, receiverEl, false);
            break;
        case 'toggleLangMenu':
            toggleLangMenu(triggerEl);
            break;
        case 'scrollToNextSection':
            scrollToNextSection(triggerEl);
            break;
        default:
            break;
    }
}

//hover event cb
function hoverCB(triggerEl, receiverEl, mouseEnter) {
    let evType = triggerEl.getAttribute('data-evtype');
    switch (evType) {
        case 'triggerDesktopSubmenu':
            toggleDesktopSubmenu(triggerEl, receiverEl, mouseEnter);
            break;
        default:
            break;
    }
}

// scroll event cb
function scrollCB(scrollReceivers) {
    for (let el of scrollReceivers) {
        let evType = el.getAttribute('data-evtype');
        switch (evType) {
            case 'headerScroll':
                headerReceivedScroll(el);
                break;
            default:
                break;
        }
    }
}

//trigger mobile navigation open/closed
function triggerMobileNav(triggerEl) {
    let navBar = document.querySelector('#mobileNav');
    let headerEl = triggerEl.closest('.header-container');
    let navContainer = triggerEl.closest('.nav-container');

    let headerHeight = headerEl.getBoundingClientRect().height;

    if (triggerEl.classList.contains('icons-BurgerMenuicon')){
        triggerEl.classList.remove('icons-BurgerMenuicon');
        triggerEl.classList.add('icons-CloseIcon');

        navBar.classList.remove('hidden');
        navBar.setAttribute('style', 'height:calc(100% - '+headerHeight+'px)')

        navContainer.classList.add('h-screen');
        document.documentElement.classList.add('overflow-y-hidden');

        headerEl.classList.add('header-open');

        if(headerEl.classList.contains('bg-transparent') && window.scrollY === 0) {
            headerEl.classList.remove('bg-transparent');
            headerEl.classList.add('bg-blue');
        }
    } else {
        triggerEl.classList.remove('icons-CloseIcon');
        triggerEl.classList.add('icons-BurgerMenuicon');

        navBar.classList.add('hidden');
        navContainer.classList.remove('h-screen');
        document.documentElement.classList.remove('overflow-y-hidden');

        headerEl.classList.remove('header-open');
        if(headerEl.classList.contains('bg-blue') && window.scrollY === 0) {
            headerEl.classList.remove('bg-blue');
            headerEl.classList.add('bg-transparent');
        }
    }
}

//toggle mobile header submenus
function toggleMobileSubmenu(triggerEl, receiverEl, openMenu) {
    let submenuEl = document.querySelector(".header-submenu[data-evreceives='"+receiverEl+"']");
    let mainMenuEls = document.querySelectorAll(".header-menu-item");
    let headerFooter = document.querySelector(".header-menu-footer");

    if(openMenu) {
        for(let mainMenuEl of mainMenuEls) {
            mainMenuEl.classList.add('hidden');
        }

        headerFooter.classList.add('hidden');
        triggerEl.classList.add('hidden');
        submenuEl.classList.remove('hidden');
    } else {
        let subMenuButtons = document.querySelectorAll('.header-submenu-button');

        submenuEl.classList.add('hidden');
        headerFooter.classList.remove('hidden');

        for(let mainMenuEl of mainMenuEls) {
            if(mainMenuEl.classList.contains('hidden')) {
                mainMenuEl.classList.remove('hidden');
            }
        }
        for (let subMenuButton of subMenuButtons) {
            if(subMenuButton.classList.contains('hidden')) {
                subMenuButton.classList.remove('hidden');
            }
        }
    }
}

//toggle desktop header submenus
function toggleDesktopSubmenu(triggerEl, receiverEl, openMenu) {
    let mainHeader = document.querySelector('.header-main');
    let subHeader = document.querySelector('.header-submenu-d');
    let subMenus = document.querySelectorAll('.header-submenu-d [data-evreceives]')
    let subMenuEl = document.querySelector('.header-submenu-d [data-evreceives="'+receiverEl+'"]');

    if (openMenu) {
        if(mainHeader.classList.contains('bg-transparent')) {
            mainHeader.classList.remove('bg-transparent');
            mainHeader.classList.add('bg-blue');
        }
        mainHeader.classList.add('submenu-open', 'border-b-4', 'border-yellow');
        subHeader.classList.remove('hidden');

        for (let subMenu of subMenus) {
            if (!subMenu.classList.contains('hidden')) {
                subMenu.classList.add('hidden');
            }
        }
        subMenuEl.classList.remove('hidden');

        mainHeader.addEventListener('mouseleave', () => toggleDesktopSubmenu(triggerEl, receiverEl, false));
    } else {
        if(window.scrollY === 0 && mainHeader.classList.contains('bg-blue')) {
            mainHeader.classList.remove('bg-blue');
            mainHeader.classList.add('bg-transparent');
        }
        mainHeader.classList.remove('submenu-open', 'border-b-4', 'border-yellow');
        subHeader.classList.add('hidden');
        subMenuEl.classList.add('hidden');

        mainHeader.removeEventListener('mouseleave', () => toggleDesktopSubmenu(triggerEl, receiverEl, false))
    }
}

//toggle language picker open/closed
function toggleLangMenu(triggerEl) {
    if(window.innerWidth < breakpoints('lg')) {
        let languageDD = document.querySelector('.language-dd-mobile');
        languageDD.classList.toggle('hidden');
    } else {
        if (window.innerWidth < breakpoints('2xl')) {
            let languageDD = document.querySelector('.language-dd-xl');
            languageDD.classList.toggle('hidden');
        }
        else {
            let languageDD = document.querySelector('.language-dd');
            languageDD.classList.toggle('hidden');
        }
    }
}

//toggle header sticky and bg color on scroll
function headerReceivedScroll(triggerEl) {
    if (window.scrollY !== 0) {
        if(triggerEl.classList.contains('bg-transparent')) {
            triggerEl.classList.remove('bg-transparent');
            triggerEl.classList.add('bg-blue');
        }

        triggerEl.classList.remove('py-12');
        triggerEl.classList.add('py-6');

        triggerEl.closest('.nav-container').classList.remove('absolute');
        triggerEl.closest('.nav-container').classList.add('fixed');
    } else if (triggerEl.classList.contains('bg-blue')) {
        triggerEl.closest('.nav-container').classList.remove('fixed');
        triggerEl.closest('.nav-container').classList.add('absolute');

        triggerEl.classList.add('py-12');
        triggerEl.classList.remove('py-6');

        if (!triggerEl.classList.contains('header-open') && !triggerEl.classList.contains('submenu-open')) {
            triggerEl.classList.remove('bg-blue');
            triggerEl.classList.add('bg-transparent');
        }
    }
}

//scroll to section after this element if existing
function scrollToNextSection(triggerEl) {
    let nextSection = triggerEl.closest('section').nextElementSibling;

    if(nextSection) {
        nextSection.scrollIntoView();
    }
}
